// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Finance & tax rules  (customer side)
// The delivery fee rules a customer's bill uses (GET /public/commercial-rules), loaded once and cached for the session. Until the answer arrives — or if the request fails — it holds the site's
// long-standing default (data/delivery.ts), so a slow network never shows a bill with no delivery fee.
// Neighbours: utils/finance (deliveryFeeFor), components/CartDrawer, pages/Checkout, pages/admin/AdminProductDetail.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";
import { DEFAULT_PUBLIC_RULES, fetchPublicRules, type PublicRules } from "../utils/finance";

let cached: PublicRules | null = null;

export default function useCommercialRules(): PublicRules {
  const [rules, setRules] = useState<PublicRules>(cached ?? DEFAULT_PUBLIC_RULES);
  useEffect(() => {
    let live = true;
    fetchPublicRules().then((r) => { cached = r; if (live) setRules(r); }, () => undefined);
    return () => { live = false; };
  }, []);
  return rules;
}
